import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneInformationAboutResearchers = createAsyncThunk(
  "GetOneInformationAboutResearchers/GetOneInformationAboutResearchers",
  async (informationAboutResearchersId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/GetInformationAboutResearchersById",
        {
          informationAboutResearchersId: informationAboutResearchersId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteInformationAboutResearchers = createAsyncThunk(
  "DeleteInformationAboutResearchers/DeleteInformationAboutResearchers",
  async (informationAboutResearchersId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/DeleteInformationAboutResearchers",
        {
          informationAboutResearchersId: informationAboutResearchersId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListInformationAboutResearchers = createAsyncThunk(
  "GetListInformationAboutResearchers/GetListInformationAboutResearchers",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/GetInformationAboutResearchersListByAppGuid",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateInformationAboutResearchers = createAsyncThunk(
  "UpdateInformationAboutResearchers/UpdateInformationAboutResearchers",
  async (InformationAboutResearchersData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/UpdateInformationAboutResearchers",
        {
          informationAboutResearchersId:
            InformationAboutResearchersData.informationAboutResearchersId,
          fullName: InformationAboutResearchersData.fullName,
          workPlace: InformationAboutResearchersData.workPlace,
          phoneNumber: InformationAboutResearchersData.phoneNumber,
          email: InformationAboutResearchersData.email,
          gender: InformationAboutResearchersData.gender,
          major: InformationAboutResearchersData.major,
          academicDegreeId: InformationAboutResearchersData.academicDegreeId,
          roleInResearch: InformationAboutResearchersData.roleInResearch,
          natonalBaseResearcherNmber:
            InformationAboutResearchersData.natonalBaseResearcherNmber,
          cvDocumentAttachment:
            InformationAboutResearchersData.cvDocumentAttachment,

          applicationInformationId:
            InformationAboutResearchersData.applicationInformationId,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddInformationAboutResearchersData = createAsyncThunk(
  "AddInformationAboutResearchersData/AddInformationAboutResearchersData",
  async (InformationAboutResearchersData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/AddInformationAboutResearchers",
        {
          fullName: InformationAboutResearchersData.fullName,
          workPlace: InformationAboutResearchersData.workPlace,
          phoneNumber: InformationAboutResearchersData.phoneNumber,
          email: InformationAboutResearchersData.email,
          gender: InformationAboutResearchersData.gender,
          major: InformationAboutResearchersData.major,
          academicDegreeId: InformationAboutResearchersData.academicDegreeId,
          roleInResearch: InformationAboutResearchersData.roleInResearch,
          natonalBaseResearcherNmber:
            InformationAboutResearchersData.natonalBaseResearcherNmber,
          cvDocumentAttachment:
            InformationAboutResearchersData.cvDocumentAttachment,

          applicationInformationId:
            InformationAboutResearchersData.applicationInformationId,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateInformationAboutResearchers = createAsyncThunk(
  "ValidateInformationAboutResearchers/ValidateInformationAboutResearchers",
  async (Validate, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationAboutResearchers/ValidateInformationAboutResearchers",
        {
          fullName: Validate.fullName,
          workPlace: Validate.workPlace,
          phoneNumber: Validate.phoneNumber,
          email: Validate.email,
          gender: Validate.gender,
          major: Validate.major,
          academicDegreeId: Validate.academicDegreeId,
          roleInResearch: Validate.roleInResearch,
          natonalBaseResearcherNmber: Validate.natonalBaseResearcherNmber,
          cvDocumentAttachment: Validate.cvDocumentAttachment,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneInformationAboutResearchers = createSlice({
  name: "OneInformationAboutResearchers",
  initialState: {
    OneInformationAboutResearchers: {},
    loadingOneInformationAboutResearchers: false,
    errorOneInformationAboutResearchers: null,

    AddInformationAboutResearchers: {},
    loadingAddInformationAboutResearchers: false,
    errorAddInformationAboutResearchers: null,

    UpdateInformationAboutResearchers: {},
    loadingUpdateInformationAboutResearchers: false,
    errorUpdateInformationAboutResearchers: null,

    DeleteInformationAboutResearchers: {},
    loadingDeleteInformationAboutResearchers: false,
    errorDeleteInformationAboutResearchers: null,

    ListInformationAboutResearchers: {},
    loadingListInformationAboutResearchers: false,
    errorListInformationAboutResearchers: null,

    InformationAboutResearchersValidate: [],
    loadingInformationAboutResearchersValidate: false,
    errorInformationAboutResearchersValidate: null,
  },
  reducers: {
    restValidateInformationAboutResearchers: (state, action) => {
      state.InformationAboutResearchersValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneInformationAboutResearchers.pending, (state, action) => {
        state.loadingOneInformationAboutResearchers = true;
        state.OneInformationAboutResearchers = action.payload;
        state.errorOneInformationAboutResearchers = null;
      })
      .addCase(GetOneInformationAboutResearchers.fulfilled, (state, action) => {
        state.loadingOneInformationAboutResearchers = false;
        state.OneInformationAboutResearchers = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneInformationAboutResearchers.rejected, (state, action) => {
        state.loadingOneInformationAboutResearchers = false;
        state.errorOneInformationAboutResearchers = action.payload;
      })

      .addCase(DeleteInformationAboutResearchers.pending, (state, action) => {
        state.loadingDeleteInformationAboutResearchers = true;
        state.DeleteInformationAboutResearchers = action.payload;
        state.errorDeleteInformationAboutResearchers = null;
      })
      .addCase(DeleteInformationAboutResearchers.fulfilled, (state, action) => {
        state.DeleteInformationAboutResearchers = false;
        state.DeleteInformationAboutResearchers = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteInformationAboutResearchers.rejected, (state, action) => {
        state.loadingDeleteInformationAboutResearchers = false;
        state.errorDeleteInformationAboutResearchers = action.payload;
      })
      .addCase(GetListInformationAboutResearchers.pending, (state, action) => {
        state.loadingListInformationAboutResearchers = true;
        state.ListInformationAboutResearchers = action.payload;
        state.errorListInformationAboutResearchers = null;
      })
      .addCase(
        GetListInformationAboutResearchers.fulfilled,
        (state, action) => {
          state.loadingListInformationAboutResearchers = false;
          state.ListInformationAboutResearchers = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetListInformationAboutResearchers.rejected, (state, action) => {
        state.loadingListInformationAboutResearchers = false;
        state.errorListInformationAboutResearchers = action.payload;
      })
      .addCase(UpdateInformationAboutResearchers.pending, (state, action) => {
        state.loadingUpdateInformationAboutResearchers = true;
        state.UpdateInformationAboutResearchers = action.payload;
        state.errorUpdateInformationAboutResearchers = null;
      })
      .addCase(UpdateInformationAboutResearchers.fulfilled, (state, action) => {
        state.loadingUpdateInformationAboutResearchers = false;
        state.UpdateInformationAboutResearchers = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateInformationAboutResearchers.rejected, (state, action) => {
        state.loadingUpdateInformationAboutResearchers = false;
        state.errorUpdateInformationAboutResearchers = action.payload;
      })
      .addCase(ValidateInformationAboutResearchers.pending, (state, action) => {
        state.loadingInformationAboutResearchersValidate = true;
        state.InformationAboutResearchersValidate = action.payload;
        state.errorInformationAboutResearchersValidate = null;
      })
      .addCase(
        ValidateInformationAboutResearchers.fulfilled,
        (state, action) => {
          state.loadingInformationAboutResearchersValidate = false;
          state.InformationAboutResearchersValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateInformationAboutResearchers.rejected,
        (state, action) => {
          state.loadingInformationAboutResearchersValidate = false;
          state.errorInformationAboutResearchersValidate = action.payload;
        }
      )
      .addCase(AddInformationAboutResearchersData.pending, (state, action) => {
        state.loadingAddInformationAboutResearchers = true;
        state.AddInformationAboutResearchers = action.payload;
        state.errorAddInformationAboutResearchers = null;
      })
      .addCase(
        AddInformationAboutResearchersData.fulfilled,
        (state, action) => {
          state.loadingAddInformationAboutResearchers = false;
          state.AddInformationAboutResearchers = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(AddInformationAboutResearchersData.rejected, (state, action) => {
        state.loadingAddInformationAboutResearchers = false;
        state.errorAddInformationAboutResearchers = action.payload;
      });
  },
});
export const { restValidateInformationAboutResearchers } =
  OneInformationAboutResearchers.actions;
export default OneInformationAboutResearchers.reducer;
